import { Button, Stack, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { useGetSKUQuery, useLazyListSKUsQuery, useListSKUsQuery } from "../../features/model/skuSlice";
import { useLazyListSKUMetadatasQuery } from "../../features/model/skumetadataSlice";

const PurchaseOrderCustomItemView = ({onAddCustomItem}) => {
    const [custom, setCustom] = useState("");
    const [errorText, setErrorText] = useState("");
    const [successText, setSuccessText] = useState("");
    const [searchSKU] = useLazyListSKUsQuery();
    const [getSKUMeta] = useLazyListSKUMetadatasQuery();

    const onAdd = async () => {
        setErrorText("");
        setSuccessText("");
        const response = await searchSKU({code: custom});
        if(!response.data){
            setErrorText("Request failed:" + response.error.error);
            return;
        }
        if(response.data.objects.length === 0) {
            setErrorText("No match found. Please check the custom item ID.")
            return;
        }
        const sku = response.data.objects[0];
        // found a match! get all the metadata
        const sku_id = sku.id;
        const meta_response = await getSKUMeta({SKU: sku_id});
        if(!meta_response.data) {
            setErrorText("Request failed:" + meta_response.error.error);
            return;
        }
        // get the sheet name and other keys
        const meta = Object.fromEntries(meta_response.data.objects.map(x => [x.key, x]));
        if(!("custom_sheet" in meta)) {
            setErrorText("No match found, please check the custom item ID.");
            return;
        }
        onAddCustomItem(sku, meta);
        setSuccessText(`Item "${sku.name}" added.`);
        setCustom("");
    };

    return <Stack direction="row" spacing={2} alignItems={"stretch"}>
        <TextField value={custom} onKeyDown={(e) => {if (e.key === 'Enter') {onAdd()}}} onChange={(e) => {setCustom(e.target.value)}} label={custom === "" ? "Enter a custom item ID" : ""}></TextField>
        <Button variant="outlined" disabled={custom === ""} onClick={onAdd}>Add</Button>
        <Typography alignContent={"center"} variant="caption" color="red">{errorText}</Typography>
        <Typography alignContent={"center"} variant="caption">{successText}</Typography>
    </Stack>
}

export {PurchaseOrderCustomItemView}